import { motion } from "framer-motion";
import { ExternalLink, ShoppingCart, CreditCard, Search } from "lucide-react";
import { PARTNER_LINK } from "@/lib/constants";

const steps = [
  {
    number: "1",
    icon: Search,
    title: "Partnerlink öffnen",
    text: "Öffne den offiziellen heilys Shop über den Partnerlink auf dieser Seite. Damit unterstützt du unsere unabhängige Arbeit – ohne Mehrkosten für dich.",
  },
  {
    number: "2",
    icon: ShoppingCart,
    title: "Produkte auswählen",
    text: "Stöbere im heilys Sortiment (Gen30+Vision, AddRed, Panels, Wearables) und lege deine gewünschten Produkte in den Warenkorb.",
  },
  {
    number: "3",
    icon: CreditCard,
    title: "Im Checkout bestellen",
    text: "Im Checkout siehst du die aktuellen Konditionen des offiziellen heilys Shops. Sie gelten dort für alle Kunden gleichermaßen.",
  },
];

const HowToSection = () => (
  <section id="anleitung" className="bg-card/50 py-10 md:py-20">
    <div className="container">
      <h2 className="text-center font-display text-xl font-bold text-foreground sm:text-2xl md:text-3xl">
        So kaufst du heilys über den Partnerlink
      </h2>
      <p className="mx-auto mt-2 max-w-2xl text-center text-sm text-muted-foreground md:mt-3 md:text-base">
        Der Ablauf ist einfach: Partnerlink öffnen, Produkte auswählen, im offiziellen Shop bestellen.
      </p>

      <div className="mx-auto mt-8 md:mt-10 grid max-w-4xl gap-4 sm:gap-5 grid-cols-1 sm:grid-cols-3">
        {steps.map((step, i) => (
          <motion.div
            key={step.number}
            initial={{ opacity: 0.4, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ delay: i * 0.06, duration: 0.3 }}
            className="relative rounded-xl border border-border/50 bg-card p-4 sm:p-5 text-center transition-all hover:border-primary/20"
          >
            <span className="font-display text-2xl sm:text-3xl font-extrabold text-primary/15" aria-hidden="true">
              {step.number}
            </span>
            <div className="mx-auto mt-1.5 sm:mt-2 inline-flex items-center justify-center rounded-lg bg-primary/10 p-1.5 sm:p-2">
              <step.icon className="h-4 w-4 sm:h-5 sm:w-5 text-primary" aria-hidden="true" />
            </div>
            <h3 className="mt-2 sm:mt-3 font-display text-sm font-semibold text-foreground">
              {step.title}
            </h3>
            <p className="mt-1 sm:mt-1.5 text-xs sm:text-sm leading-relaxed text-muted-foreground">{step.text}</p>
          </motion.div>
        ))}
      </div>

      <div className="mt-6 sm:mt-8 flex justify-center">
        <a
          href={PARTNER_LINK}
          target="_blank"
          rel="sponsored noopener noreferrer"
          onClick={() => window.lh?.trackAffiliate({ source: "howto" })}
          className="inline-flex items-center justify-center gap-1.5 rounded-lg bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground shadow-lg shadow-primary/20 transition-all hover:brightness-110"
        >
          Zum heilys Shop
          <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
        </a>
      </div>
    </div>
  </section>
);

export default HowToSection;
